// Custom components
function InputField(props: {
    id: string;
    label: string;
    extra?: string;
    placeholder: string;
    variant?: string;
    state?: string;
    disabled?: boolean;
    type?: string;
    onChange?: any;
    defaultValue?: string;
    value?: string;
}) {
    const {
        label,
        id,
        extra,
        type,
        placeholder,
        variant,
        state,
        disabled,
        onChange,
        defaultValue,
        value,
    } = props;

    return (
        <div className={`${extra}`}>
            <label
                htmlFor={id}
                className={`text-xs font-semibold text-gray-700 dark:text-white ${
                    variant === 'auth' ? 'ml-1' : 'ml-1'
                }`}
            >
                {label}
            </label>
            <input
                onChange={onChange}
                disabled={disabled}
                defaultValue={defaultValue}
                value={value}
                type={type}
                id={id}
                placeholder={placeholder}
                className={`mt-1.5 flex h-10 w-full items-center justify-center rounded-lg border-2 bg-white px-3 text-sm outline-none transition-all duration-200 ${
                    disabled === true
                        ? '!border-gray-200 !bg-gray-50 text-gray-400 cursor-not-allowed'
                        : state === 'error'
                        ? 'border-red-400 bg-red-50/50 text-gray-900 placeholder:text-red-300 focus:border-red-500 focus:bg-white focus:ring-4 focus:ring-red-100'
                        : state === 'success'
                        ? 'border-green-400 bg-green-50/50 text-gray-900 placeholder:text-green-300 focus:border-green-500 focus:bg-white focus:ring-4 focus:ring-green-100'
                        : 'border-gray-200 text-gray-900 placeholder:text-gray-400 focus:border-brand-500 focus:bg-white focus:ring-4 focus:ring-brand-100 hover:border-gray-300'
                }`}
            />
        </div>
    );
}

export default InputField;
